import { isUndefined } from 'lodash';
import { format } from 'd3-format';

function percent() {
  'ngInject';
  return function(number, allowZero, round) {

    round = isUndefined(round) || round > 2 ? 2 : round;

    if (!number && allowZero) {
      return '0.00%';
    }

    if (!number) {
      return 'n/a';
    }

    return format('.' + round + '%')(number);

  };
}

export { percent };
